// src/pages/Home.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as commApi from "../api/community";
import * as evtApi from "../api/events";
import bgImg from "../assets/1.png";

export default function Home() {
  const navigate = useNavigate();
  const [commCount, setCommCount] = useState(0);
  const [eventCount, setEventCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        // both APIs always return { rows, total, ... } in our earlier helpers
        const c = await commApi.listCommunitiesPaged({ paged: true, limit: 1 });
        const e = await evtApi.listEventsPaged({ paged: true, limit: 1 });
        if (!mounted) return;
        setCommCount(Number(c?.total ?? c?.rows?.length ?? 0));
        setEventCount(Number(e?.total ?? e?.rows?.length ?? 0));
      } catch {
        if (!mounted) return;
        setCommCount(0);
        setEventCount(0);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return (
    <section className="home-wrap">
      <style>{`
        :root {
          --royal-red: #7A133D;
          --heritage-red: #C62039;
          --royal-gold: #D2A857;
          --royal-cream: #FFF9F2;
          --sage: #8BBAA1;
          --teal: #056675;
        }
        .home-wrap {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1rem;
          background-image: url(${bgImg}), linear-gradient(135deg, rgba(210,168,87,0.7), rgba(139,186,161,0.7), rgba(5,102,117,0.7));
          background-size: cover;
          background-position: center;
          font-family: "Merriweather", "Georgia", serif;
        }
        .home-card {
          width: 100%;
          max-width: 68rem;
          background: #ffffffcc;
          border-radius: 1rem;
          box-shadow: 0 10px 25px rgba(0,0,0,.08);
          padding: 1.25rem;
        }
        .home-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
          margin-bottom: 1rem;
        }
        .home-title {
          color: var(--royal-red);
          font-weight: 900;
          font-size: 1.75rem;
        }
        .grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 1rem;
        }
        @media (max-width: 720px) {
          .grid { grid-template-columns: 1fr; }
        }
        .tile {
          background: #fff;
          border: 1px solid rgba(0,0,0,.08);
          border-radius: 0.75rem;
          padding: 1rem;
          display: grid;
          gap: .5rem;
        }
        .tile h3 {
          margin: 0;
          color: var(--heritage-red);
          font-size: 1.2rem;
          font-weight: 800;
        }
        .count {
          font-size: 2rem;
          font-weight: 900;
          color: var(--teal);
        }
        .actions {
          display: flex;
          gap: .5rem;
          flex-wrap: wrap;
        }
        .btn {
          border: none;
          border-radius: .5rem;
          padding: .5rem .8rem;
          font-weight: 700;
          cursor: pointer;
        }
        .view { background: var(--royal-gold); color: #fff; }
        .add  { background: var(--heritage-red); color: #fff; }
      `}</style>

      <div className="home-card">
        <div className="home-header">
          <h2 className="home-title">Dashboard</h2>
          {loading && <div>Loading…</div>}
        </div>

        <div className="grid">
          {/* Communities */}
          <div className="tile">
            <h3>Communities</h3>
            <div className="count">{commCount}</div>
            <div className="actions">
              <button className="btn view" onClick={() => navigate('/communities')}>View</button>
              <button className="btn add"  onClick={() => navigate('/community/new')}>+ Add</button>
            </div>
          </div>

          {/* Events */}
          <div className="tile">
            <h3>Events</h3>
            <div className="count">{eventCount}</div>
            <div className="actions">
              <button className="btn view" onClick={() => navigate('/events')}>View</button>
              <button className="btn add"  onClick={() => navigate('/events/new')}>+ Add</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
